import React, { useEffect, useRef, useCallback, useMemo } from "react";
import "./FallingElements.css";

const FallingElements = () => {
  const containerRef = useRef(null);
  const activeElements = useRef(0); // Contador de elementos activos
  const animationFrameRef = useRef(null); // Usamos useRef en lugar de una variable local
  const MAX_ELEMENTS = 5; // Máximo de elementos simultáneos

  const images = useMemo(
    () => [
      "url('/img/sanvalentin.png')",
      "url('/img/corazon.png')",
      "url('/img/globo.png')",
    ],
    []
  );

  const getRandomStyles = useCallback(() => ({
    left: `${Math.random() * 100}vw`,
    animationDuration: `${Math.random() * 5 + 3}s`, // Entre 3s y 8s
    animationDelay: `${Math.random() * 2}s`,
    transform: `rotate(${Math.random() * 360}deg)`,
    backgroundImage: images[Math.floor(Math.random() * images.length)],
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    width: `${Math.random() * 20 + 30}px`, // Tamaño entre 20px y 40px
    height: `${Math.random() * 20 + 30}px`,
  }), [images]);

  const createFallingElement = useCallback(() => {
    if (activeElements.current >= MAX_ELEMENTS || !containerRef.current) return;

    const element = document.createElement("div");
    element.classList.add("falling");

    Object.assign(element.style, getRandomStyles());

    containerRef.current.appendChild(element);
    activeElements.current += 1;

    element.addEventListener("animationend", () => {
      if (containerRef.current) {
        containerRef.current.removeChild(element);
        activeElements.current -= 1;
      }
    });
  }, [getRandomStyles]);

  useEffect(() => {
    const container = containerRef.current; // Guardamos el valor de ref antes de usarlo

    const generateElements = () => {
      if (!container) return;
      createFallingElement();
      animationFrameRef.current = requestAnimationFrame(() => setTimeout(generateElements, 1000));
    };

    generateElements();

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
      if (container) {
        container.innerHTML = ""; // Limpia elementos al desmontar
      }
    };
  }, [createFallingElement]);

  return <div id="falling-elements" ref={containerRef}></div>;
};

export default FallingElements;






